import React, { useState, useEffect } from 'react';

const ComponentCategoryForm = ({ category, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    category_name: '',
    category_description: ''
  });

  useEffect(() => {
    if (category) {
      setFormData({
        category_name: category.category_name || '',
        category_description: category.category_description || ''
      });
    }
  }, [category]);

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Name:
        <input name="category_name" value={formData.category_name} onChange={handleChange} required />
      </label>
      <label>
        Description:
        <input name="category_description" value={formData.category_description} onChange={handleChange} />
      </label>
      <button type="submit">Save</button>
      <button type="button" onClick={onCancel}>Cancel</button>
    </form>
  );
};

export default ComponentCategoryForm;